var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "language-selection" }, [
    _c(
      "button",
      {
        class: [{ active: _vm.language === "fi" }, "btn btn-link language-fi"],
        attrs: {
          lang: "fi",
          "aria-label": _vm.languageAriaLabelFi,
          onclick: "return false;"
        },
        on: {
          click: function($event) {
            return _vm.setLanguage("fi")
          }
        }
      },
      [_vm._v("\n    FI\n  ")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        class: [{ active: _vm.language === "sv" }, "btn btn-link language-se"],
        attrs: {
          lang: "sv",
          "aria-label": _vm.languageAriaLabelSv,
          onclick: "return false;"
        },
        on: {
          click: function($event) {
            return _vm.setLanguage("sv")
          }
        }
      },
      [_vm._v("\n    SV\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }